import * as React from "react"
import { useForm } from "@inertiajs/react"
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/Card"
import { Button } from "@/components/ui/Button"
import { Input } from "@/components/ui/Input"
import { settings_profile_password_path } from "@/lib/routes"

const fieldError = (msgs: string | string[] | undefined) => {
  if (!msgs) return null
  return (
    <span className="text-xs text-destructive">
      {Array.isArray(msgs) ? msgs.join(", ") : msgs}
    </span>
  )
}

export default function PasswordForm() {
  const { data, setData, patch, processing, errors, reset, transform } = useForm({
    current_password: "",
    password: "",
    password_confirmation: "",
  })

  transform(({ current_password, ...rest }) => ({
    current_password,
    user: rest,
  }))

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(settings_profile_password_path(), {
      preserveScroll: true,
      onSuccess: () => reset(),
    })
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Change password</CardTitle>
        <CardDescription>Minimum 8 characters.</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={submit} className="flex flex-col gap-4 max-w-sm">
          <div className="flex flex-col gap-1.5">
            <label htmlFor="current-password" className="text-sm font-medium">Current password</label>
            <Input
              id="current-password"
              type="password"
              autoComplete="current-password"
              value={data.current_password}
              onChange={(e) => setData("current_password", e.target.value)}
              disabled={processing}
            />
            {fieldError(errors.current_password)}
          </div>

          <div className="flex flex-col gap-1.5">
            <label htmlFor="new-password" className="text-sm font-medium">New password</label>
            <Input
              id="new-password"
              type="password"
              autoComplete="new-password"
              value={data.password}
              onChange={(e) => setData("password", e.target.value)}
              disabled={processing}
            />
            {fieldError(errors.password)}
          </div>

          <div className="flex flex-col gap-1.5">
            <label htmlFor="confirm-password" className="text-sm font-medium">Confirm new password</label>
            <Input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              value={data.password_confirmation}
              onChange={(e) => setData("password_confirmation", e.target.value)}
              disabled={processing}
            />
            {fieldError(errors.password_confirmation)}
          </div>

          <div>
            <Button type="submit" disabled={processing}>
              {processing ? "Updating…" : "Update password"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  )
}
